exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper {\r\n  margin-top: 56px;\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n}\r\n\r\n.app-content {\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/layout.component.css
// module id = ../../../../../src/app/layout/layout.component.css
// module chunks = main